export default {
	user: 'utilisateur',
	intervention: 'intervention',
	userCreate: "Ajout d'un utilisateur",
	userUpdate: "Edition d'un utilisateur",
	userDelete: "Supression d'un utilisateur",
	interventionCreate: "Ajout d'une intervention",
}
